import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'signupRecruiter',
  storage: process.browser ? localStorage : undefined,
});

export interface CompanyAttributes {
  id?: string;
  name?: string;
  website?: string;
  isNewCompany?: boolean;
}

export interface UserAttributes {
  email?: string;
}

interface SingupRecruiter {
  user?: UserAttributes;
  company?: CompanyAttributes;
  step: number;
}

export const signUpRecruiterState = atom<SingupRecruiter>({
  key: 'singupRecruiter',
  default: { step: 0, company: { isNewCompany: false } },
  effects_UNSTABLE: [persistAtom],
});
